import Modal from "react-modal";
import iconHandOk from "../assets/images/atrapame-si-puedes/Group.svg";
import {useTranslation} from "react-i18next";

Modal.setAppElement("#root");

export const DialogRedeem = ({isOpen, toggleModal}) => {
  const {t} = useTranslation();

  const goBonusPage = () => {
    window.navigation.postMessage("native,,,bonus-page,");
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={toggleModal}
      contentLabel="My dialog"
      className="asp-modal"
      closeTimeoutMS={200}
    >
      <div className="asp-modal-container">
        <div className="asp-modal-container-top">
          <img
            className="asp-modal-container-top-card-icon-hand"
            src={iconHandOk}
            alt="Icon Hand"
          />
          <div className="asp-modal-container-top-title-container">
            <p className="asp-modal-container-top-title-text">
              {t("atrapaqr.dialogRedeem.ready")}
            </p>
            <p className="asp-modal-container-top-title-text">
              {t("atrapaqr.dialogRedeem.title")}
            </p>
          </div>
        </div>
        <p className="asp-modal-container-text">
          {t("atrapaqr.dialogRedeem.text1")}
          <strong>{t("atrapaqr.dialogRedeem.textBold1")}</strong>
          {t("atrapaqr.dialogRedeem.text2")}
          <strong>{t("atrapaqr.dialogRedeem.textBold2")}</strong>
        </p>
        <div className="asp-modal-buttons-container">
          <button
            className="asp-modal-buttons-container-close"
            onClick={toggleModal}
          >
            {t("atrapaqr.dialogRedeem.buttonClose")}
          </button>
          <button
            className="asp-modal-buttons-container-bonificaciones"
            onClick={goBonusPage}
          >
            {t("atrapaqr.dialogRedeem.buttonMyBonuses")}
          </button>
        </div>
      </div>
    </Modal>
  );
};
